import { useMutation } from '@apollo/client';
import React, { useContext, useEffect } from 'react';
import { AppContext } from '../../AppContext';
import { ROUTES } from '../../common/constants';
import LoaderComponent from '../../components/LoaderComponent';
import useRouter from '../../hooks/useRouter';
import { LOGOUT_USER } from './graphql/Queries';

const Logout = () => {
  const { dispatch } = useContext(AppContext);
  const { navigate } = useRouter();
  const [logout, { loading, error, data }] = useMutation(LOGOUT_USER, {
    onError() {},
  });

  useEffect(() => {
    logout();
  }, []);

  if (loading) return <LoaderComponent />;

  if (error) {
    if (error?.graphQLErrors?.length) {
      dispatch({ type: 'LOGOUT' });
      // eslint-disable-next-line no-undef
      window.location = ROUTES.LOGIN;
      return null;
    }

    navigate(-1);
    return null;
  }

  if (data) {
    dispatch({ type: 'LOGOUT' });
    return null;
  }

  return null;
};

export default Logout;
